import { render, staticRenderFns } from "./FluxoCaixaSaldoTotal.vue?vue&type=template&id=1050728e&scoped=true&"
import script from "./FluxoCaixaSaldoTotal.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixaSaldoTotal.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixaSaldoTotal.vue?vue&type=style&index=0&id=1050728e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050728e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
